const MONTH_ABBR = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

/**
 * "Jul 25 - Jul 26" — the trailing 12 months up to and including the month
 * before `now`, e.g. for a `now` of August 2026 this is July 2025 through
 * July 2026 (last one year, counted from the previous month rather than the
 * current, still-incomplete one). Shared by `lmax-chart-legend`'s `${range}`
 * placeholder and `lmax-chart-range-legend`'s date-range line.
 */
export function formatRollingYearRange(now: Date = new Date()): string {
  const currentMonth = now.getMonth();
  const previousMonth = (currentMonth + 11) % 12;
  const previousMonthYear = currentMonth === 0 ? now.getFullYear() - 1 : now.getFullYear();
  const startYear = previousMonthYear - 1;

  const format = (month: number, year: number) => `${MONTH_ABBR[month]} ${String(year).slice(-2)}`;
  return `${format(previousMonth, startYear)} - ${format(previousMonth, previousMonthYear)}`;
}
